/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_LoginInputs */

const es_home_hero_login = /** @type {(inputs: Home_Hero_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar Sesión`)
};

const en_home_hero_login = /** @type {(inputs: Home_Hero_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log In`)
};

/**
* | output |
* | --- |
* | "Log In" |
*
* @param {Home_Hero_LoginInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_login = /** @type {((inputs?: Home_Hero_LoginInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_LoginInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_login(inputs)
	return en_home_hero_login(inputs)
});
export { home_hero_login as "home.hero.login" }